<template>
    <div class="card">
      <div class="card-header" v-if="$slots.header">
        <slot name="header"></slot>
      </div>
      <div class="card-body">
        <canvas ref="canvas" :width="width" :height="height"></canvas>
      </div>
      <div class="card-footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      labels: {
        type: Array,
        required: true,
      },
      data: {
        type: Array,
        required: true,
      },
      colors: {
        type: Array,
        default: () => ['rgba(54, 162, 235, 0.4)', 'rgba(75, 192, 192, 0.4)'],
      },
      borderColors: {
        type: Array,
        default: () => ['rgba(54, 162, 235, 1)', 'rgba(75, 192, 192, 1)'],
      },
      width: {
        type: Number,
        default: 600,
      },
      height: {
        type: Number,
        default: 300,
      },
    },
    mounted() {
      this.drawChart();
    },
    methods: {
  formatLabel(value) {
    if (value >= 1000000) {
      return (value / 1000000).toFixed(0) + 'M'; // Millions
    } else if (value >= 1000) {
      return (value / 1000).toFixed(0) + 'K'; // Thousands
    } else {
      return value; // Less than 1000
    }
  },

  drawChart() {
    const canvas = this.$refs.canvas;
    const ctx = canvas.getContext('2d');
    const { labels, data, colors, borderColors } = this;

    const maxValue = Math.max(...data.flat());
    const chartHeight = this.height - 60; // Adjusted for space for labels
    const chartWidth = this.width - 60;

    const xStep = chartWidth / (labels.length - 1);
    const yStep = chartHeight / maxValue;

    // Draw Y-axis grid lines
    ctx.strokeStyle = '#e0e0e0'; // Light gray color for grid lines
    ctx.lineWidth = 1;
    ctx.textAlign = 'right';
    ctx.fillStyle = '#000';
    ctx.font = '12px Arial';

    const numYSteps = 5;
    for (let i = 0; i <= numYSteps; i++) {
      const y = chartHeight - (i * (chartHeight / numYSteps)) + 20;
      ctx.beginPath();
      ctx.moveTo(30, y);
      ctx.lineTo(chartWidth + 30, y);
      ctx.stroke();

      // Y-axis labels with formatting
      const labelValue = (i * maxValue) / numYSteps;
      ctx.fillText(this.formatLabel(Math.round(labelValue)), 25, y + 5); // Adjusted X position for labels
    }

    // Draw X-axis grid lines and labels
    labels.forEach((label, index) => {
      const x = 30 + index * xStep;
      ctx.beginPath();
      ctx.moveTo(x, 20);
      ctx.lineTo(x, chartHeight + 20);
      ctx.stroke();

      // X-axis labels
      ctx.textAlign = 'center';
      ctx.fillStyle = '#000';
      ctx.font = '12px Arial';
      const yLabelPos = chartHeight + 40; // Position the labels below the chart
      ctx.fillText(label, x, yLabelPos);
    });

    data.forEach((dataset, datasetIndex) => {
      ctx.beginPath();
      ctx.moveTo(30, chartHeight - dataset[0] * yStep + 20);

      dataset.forEach((value, index) => {
        const x = 30 + index * xStep;
        const y = chartHeight - value * yStep + 20;
        ctx.lineTo(x, y);
      });

      ctx.lineTo(chartWidth + 30, chartHeight + 20);
      ctx.lineTo(30, chartHeight + 20);
      ctx.closePath();

      ctx.fillStyle = colors[datasetIndex];
      ctx.fill();

      // Draw the border line on top of the area
      ctx.beginPath();
      ctx.moveTo(30, chartHeight - dataset[0] * yStep + 20);

      dataset.forEach((value, index) => {
        const x = 30 + index * xStep;
        const y = chartHeight - value * yStep + 20;
        ctx.lineTo(x, y);
      });

      ctx.strokeStyle = borderColors[datasetIndex];
      ctx.stroke();
    });
  },
},

  };
  </script>
  
  <style scoped>
  .card-body {
    position: relative;
  }
  canvas {
    display: block;
    margin: 0 auto;
  }
  </style>
  